import Mutations from '../../odata/mutations';

export default { ...new Mutations('store'), ...new Mutations('stores') };
